module.exports = __webpack_public_path__ + "img/9788962601374.48ae592c.jpg";